<app-in-zone-assets [dataKPI]="dataKPItimeinzone"
(chartClicked)="onInZoneChartClick($event)"></app-in-zone-assets>

@if ((idAssetClicked | typeOf) === 'string') {
  <app-in-zone-cycles [dataKPI]="dataKPItimeinzone"
  [selectedAssetId]="idAssetClicked"></app-in-zone-cycles>
} @else {
  <div class="placeholder-more-kpis">{{ 'KPI_SELECT_ELEMENT' | translate }}</div>
}

